import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { useHomeRoute } from "hooks/useHomeRoute";
import { useScreenWidth } from "hooks/useScreenWidth";
import { useThemeGreyBackgroundColor } from "hooks/useThemeGreyBackgroundColor";
import { useThemeMode } from "hooks/useThemeMode";
import { QueryParamProvider } from "providers/queryParams";
import { Outlet } from "react-router-dom";

import { CommandPaletteProvider } from "./components/CommandPaletteProvider";
import { CspViolationReporter } from "./components/CspViolationReporter";
import { MinimizedDialogsToolbar } from "./components/MinimizedDialogs/MinimizedDialogsToolbar";
import { PrevNextNavigationProvider } from "./components/PrevNextNavigation";
import { SharedGoogleMapsProvider } from "./components/SharedGoogleMapsProvider";
import { BreadcrumbProvider } from "./providers/breadcrumbs";
import { DocumentAIAnalysisProvider } from "./providers/documentAIAnalysis";
import { DocumentReviewProvider } from "./providers/documentReview";
import { MinimizedDialogsProvider } from "./providers/minimizedDialogs";
import { useEncampTheme } from "./theme";

export function App() {
  const { screenMaxWidth } = useScreenWidth();

  const isHome = useHomeRoute();
  const homeBackgroundColor = useThemeGreyBackgroundColor();
  const { themeMode } = useThemeMode();

  const encampTheme = useEncampTheme();

  return (
    <QueryParamProvider>
      <CspViolationReporter />
      <ThemeProvider theme={encampTheme}>
        <CssBaseline />
        <MinimizedDialogsProvider>
          <DocumentReviewProvider>
            <DocumentAIAnalysisProvider>
              <CommandPaletteProvider>
                <PrevNextNavigationProvider>
                  <BreadcrumbProvider>
                    <SharedGoogleMapsProvider>
                      <Box
                        sx={{
                          // Override the background color for the home page. In light mode,
                          // we use a grey background for the entire page (beyond the content area defined by maxWidth).
                          backgroundColor:
                            isHome && themeMode === "light" ? homeBackgroundColor : undefined,
                        }}
                      >
                        <Box sx={screenMaxWidth ? { maxWidth: screenMaxWidth } : {}}>
                          <Outlet />
                        </Box>
                      </Box>
                      <MinimizedDialogsToolbar />
                    </SharedGoogleMapsProvider>
                  </BreadcrumbProvider>
                </PrevNextNavigationProvider>
              </CommandPaletteProvider>
            </DocumentAIAnalysisProvider>
          </DocumentReviewProvider>
        </MinimizedDialogsProvider>
      </ThemeProvider>
    </QueryParamProvider>
  );
}
